import { useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import { toggleFavoriteMedium } from "../../../../services/client";

/**
 * Toggling one medium's favourite flag: optimistic update, rollback and toast on
 * failure, and a "which card is mid-request" id so the tapped heart can disable
 * itself.
 *
 * Callers own their own state, so they pass `applyFavorite(mediumId, value)` and
 * write the flag wherever they keep it — the professional listing keeps it on
 * cards and the open profile, the favourites page keeps it on its own rows.
 */
export default function useFavoriteToggle(applyFavorite) {
  const { t } = useTranslation("clientPremium");
  const [favoritePendingId, setFavoritePendingId] = useState(null);

  const toggleFavorite = (item) => {
    const previous = item.is_favorite;

    // The heart has to feel instant, so it moves before the server answers.
    applyFavorite(item.medium_id, !previous);
    setFavoritePendingId(item.medium_id);

    toggleFavoriteMedium(item.medium_id)
      .then((res) => {
        if (!res || !res.data || !res.data.status) {
          throw new Error("toggle-favorite-medium rejected");
        }
        applyFavorite(item.medium_id, res.data.data.is_favorite);
      })
      .catch(() => {
        applyFavorite(item.medium_id, previous);
        toast.error(t("favorite.updateError"), {
          position: "top-center",
        });
      })
      .finally(() => setFavoritePendingId(null));
  };

  return { toggleFavorite, favoritePendingId };
}
